/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const e = "grid.noRecords", r = "grid.pagerInfo", t = "grid.pagerFirstPage", o = "grid.pagerPreviousPage", a = "grid.pagerNextPage", i = "grid.pagerLastPage", l = "grid.pagerItemsPerPage", g = "grid.pagerPage", s = "grid.pagerPageSizeAriaLabel", n = "grid.pagerOf", d = "grid.pagerTotalPages", p = "grid.groupPanelEmpty", c = "grid.groupColumn", u = "grid.ungroupColumn", f = "grid.columnMenu", h = "grid.filterApplyButton", A = "grid.filterClearButton", P = "grid.filterResetButton", m = "grid.filterSubmitButton", I = "grid.filterTitle", O = "grid.sortAscending", C = "grid.sortDescending", b = "grid.searchPlaceholder", L = "grid.searchboxPlaceholder", S = "grid.filterCheckAll", E = "grid.filterChooseOperator", x = "grid.filterSelectAll", R = "grid.filterSelectedItems", B = "grid.sortAriaLabel", q = "grid.filterAriaLabel", w = "grid.groupPanelAriaLabel", y = "grid.groupExpand", G = "grid.groupCollapse", N = "grid.detailExpand", D = "grid.detailCollapse", F = "grid.selectRow", T = "grid.gridAriaLabel", v = "grid.gridRowReorderAriaLabel", k = {
  [N]: "Expand detail row",
  [D]: "Collapse detail row",
  [y]: "Expand group",
  [G]: "Collapse Group",
  [e]: "No records available",
  [p]: "Drag a column header and drop it here to group by that column",
  [h]: "Apply",
  [A]: "Clear",
  [P]: "Reset",
  [m]: "Filter",
  [I]: "Filter",
  [O]: "Sort Ascending",
  [C]: "Sort Descending",
  [B]: "Sortable",
  [c]: "Group Column",
  [u]: "Ungroup Column",
  [f]: "Column menu",
  [l]: "items per page",
  [r]: "{0} - {1} of {2} items",
  [t]: "Go to the first page",
  [o]: "Go to the previous page",
  [a]: "Go to the next page",
  [i]: "Go to the last page",
  [g]: "Page",
  [s]: "Page size",
  [n]: "of",
  [d]: "{0}",
  [b]: "Search",
  [L]: "Search...",
  [S]: "Check All",
  [E]: "Choose Operator",
  [R]: "selected items",
  [x]: "Select All",
  [q]: "Filter",
  [w]: "Group panel",
  [T]: "Table",
  [v]: "Drag row",
  [F]: "Select Row",
  "grid.filterEqOperator": "Is equal to",
  "grid.filterNotEqOperator": "Is not equal to",
  "grid.filterIsNullOperator": "Is null",
  "grid.filterIsNotNullOperator": "Is not null",
  "grid.filterIsEmptyOperator": "Is empty",
  "grid.filterIsNotEmptyOperator": "Is not empty",
  "grid.filterStartsWithOperator": "Starts with",
  "grid.filterContainsOperator": "Contains",
  "grid.filterNotContainsOperator": "Does not contain",
  "grid.filterEndsWithOperator": "Ends with",
  "grid.filterGteOperator": "Is greater than or equal to",
  "grid.filterGtOperator": "Is greater than",
  "grid.filterLteOperator": "Is less than or equal to",
  "grid.filterLtOperator": "Is less than",
  "grid.filterIsTrue": "Is true",
  "grid.filterIsFalse": "Is false",
  "grid.filterBooleanAll": "(All)",
  "grid.filterAfterOrEqualOperator": "Is after or equal to",
  "grid.filterAfterOperator": "Is after",
  "grid.filterBeforeOperator": "Is before",
  "grid.filterBeforeOrEqualOperator": "Is before or equal to",
  "grid.filterAndLogic": "And",
  "grid.filterOrLogic": "Or"
};
export {
  f as columnMenu,
  D as detailCollapse,
  N as detailExpand,
  h as filterApplyButton,
  q as filterAriaLabel,
  S as filterCheckAll,
  E as filterChooseOperator,
  A as filterClearButton,
  P as filterResetButton,
  x as filterSelectAll,
  R as filterSelectedItems,
  m as filterSubmitButton,
  I as filterTitle,
  T as gridAriaLabel,
  v as gridRowReorderAriaLabel,
  G as groupCollapse,
  c as groupColumn,
  y as groupExpand,
  w as groupPanelAriaLabel,
  p as groupPanelEmpty,
  k as messages,
  e as noRecords,
  t as pagerFirstPage,
  r as pagerInfo,
  l as pagerItemPerPage,
  i as pagerLastPage,
  a as pagerNextPage,
  n as pagerOf,
  g as pagerPage,
  s as pagerPageSizeAriaLabel,
  o as pagerPreviousPage,
  d as pagerTotalPages,
  b as searchPlaceholder,
  L as searchboxPlaceholder,
  F as selectRow,
  B as sortAriaLabel,
  O as sortAscending,
  C as sortDescending,
  u as ungroupColumn
};
